// import React, { useState } from "react";
// import DatePicker from "react-multi-date-picker";
// import CustomButton from "./CustomButton";
// import { TextField } from "@mui/material";
// import { InputAdornment } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// const CustomCalender = ({
//   onDateRangeChange,
//   allowDates = "both", // "future", "past", "both"
//   defaultRange = null,
//   shortcuts = [], // Dynamic buttons
//   style = {},
//   renderTrue = false,
// }) => {
//   const [dateRange, setDateRange] = useState(defaultRange);

//   const isDateAllowed = (date) => {
//     const today = new Date();
//     const d = new Date(date);

//     if (allowDates === "future") return d >= today;
//     if (allowDates === "past") return d <= today;
//     return true;
//   };

//   const triggerRangeChange = (range) => {
//     if (range && range.length === 2) {
//       const [startDate, endDate] = range;
//       const datesInRange = [];

//       for (
//         let dt = new Date(startDate);
//         dt <= endDate;
//         dt.setDate(dt.getDate() + 1)
//       ) {
//         datesInRange.push(new Date(dt));
//       }

//       setDateRange([startDate, endDate]);
//       onDateRangeChange([startDate, endDate], datesInRange, {
//         startDate: new Date(startDate).toISOString(),
//         endDate: new Date(endDate).toISOString(),
//       });
//     }
//   };

//   // Custom input component to match Material-UI style
//   const CustomInput = ({ value, onClick }) => (
//     <TextField
//       style={{ marginTop: "14px" }}
//       variant="standard"
//       value={value || ""}
//       onClick={onClick}
//       placeholder="Select Date"
//       fullWidth
//       InputProps={{
//         readOnly: true,
//         endAdornment: (
//           <InputAdornment position="end">
//             <CalendarTodayIcon fontSize="small" />
//           </InputAdornment>
//         ),
//       }}
//     />
//   );

//   return (
//     <DatePicker
//       range
//       value={dateRange}
//       onChange={(range) => triggerRangeChange(range)}
//       format="YYYY-MM-DD"
//       {...(renderTrue && {
//         render: (value, openCalendar) => (
//           <CustomInput value={value} onClick={openCalendar} />
//         ),
//       })}
//       style={{
//         border: "none",
//         height: "30px",
//         paddingLeft: "7px",
//         borderRadius: "5px",
//         width: "120px",
//         // backgroundColor: "#f8f8f8",
//         ...style,
//       }}
//       editable={false}
//       placeholder="Select Date"
//       sort
//       plugins={[
//         shortcuts.length > 0 ? (
//           <CustomButton
//             buttons={shortcuts.map((btn) => ({
//               name: btn.name,
//               onClick: () => triggerRangeChange(btn.range()),
//             }))}
//           />
//         ) : null,
//       ]}
//       mapDays={({ date }) => {
//         if (!isDateAllowed(date.toDate())) {
//           return {
//             disabled: true,
//             style: { color: "#ccc", backgroundColor: "#f8f8f8" },
//           };
//         }
//       }}
//     />
//   );
// };

// export default CustomCalender;

import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import CustomButton from "./CustomButton";
import { TextField } from "@mui/material";
import { InputAdornment } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const CustomCalender = ({
  onDateRangeChange,
  allowDates = "both", // "future", "past", "both"
  defaultRange = null,
  shortcuts = [], // Dynamic buttons
  style = {},
  renderTrue = false,
}) => {
  const [dateRange, setDateRange] = useState(defaultRange);

  const isDateAllowed = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today's date
    const d = new Date(date);
    d.setHours(0, 0, 0, 0); // Normalize the comparison date

    if (allowDates === "future") return d >= today;
    if (allowDates === "past") return d <= today;
    return true;
  };

  // const triggerRangeChange = (range) => {
  //   if (range && range.length === 2) {
  //     const [startDate, endDate] = range;
  //     const datesInRange = [];

  //     // Create a new date object to avoid modifying the original
  //     const currentDate = new Date(startDate);
  //     const endDateObj = new Date(endDate);

  //     // Include the end date in the range
  //     while (currentDate <= endDateObj) {
  //       datesInRange.push(new Date(currentDate));
  //       currentDate.setDate(currentDate.getDate() + 1);
  //     }

  //     setDateRange([startDate, endDate]);
  //     onDateRangeChange([startDate, endDate], datesInRange, {
  //       startDate: new Date(startDate).toISOString(),
  //       endDate: new Date(endDate).toISOString(),
  //     });
  //   }
  // };

  // Custom input component to match Material-UI style
  
  const triggerRangeChange = (range) => {
    if (range && range.length === 2) {
      const [startDate, endDate] = range;
      const datesInRange = [];

      // Create a new date object to avoid modifying the original
      const currentDate = new Date(startDate);
      const endDateObj = new Date(endDate);
      
      // Normalize both dates to midnight (00:00:00) to ensure accurate comparison
      currentDate.setHours(0, 0, 0, 0);
      endDateObj.setHours(0, 0, 0, 0);

      // Include the end date in the range
      while (currentDate <= endDateObj) {
        datesInRange.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      // Normalize dates before setting range to ensure consistency
      const normalizedStartDate = new Date(startDate);
      normalizedStartDate.setHours(0, 0, 0, 0);
      const normalizedEndDate = new Date(endDate);
      normalizedEndDate.setHours(0, 0, 0, 0);

      setDateRange([normalizedStartDate, normalizedEndDate]);
      onDateRangeChange([normalizedStartDate, normalizedEndDate], datesInRange, {
        startDate: normalizedStartDate.toISOString(),
        endDate: normalizedEndDate.toISOString(),
      });
    }
  };
  const CustomInput = ({ value, onClick }) => (
    <TextField
      style={{ marginTop: "14px" }}
      variant="standard"
      value={value || ""}
      onClick={onClick}
      placeholder="Select Date"
      fullWidth
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <CalendarTodayIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );

  return (
    <DatePicker
      range
      value={dateRange}
      onChange={(range) => triggerRangeChange(range)}
      format="YYYY-MM-DD"
      {...(renderTrue && {
        render: (value, openCalendar) => (
          <CustomInput value={value} onClick={openCalendar} />
        ),
      })}
      style={{
        border: "none",
        height: "20px",
        paddingLeft: "7px",
        borderRadius: "5px",
        width: "100px",
        ...style,
      }}
      editable={false}
      placeholder="Select Date"
      sort
      plugins={[
        shortcuts.length > 0 ? (
          <CustomButton
            buttons={shortcuts.map((btn) => ({
              name: btn.name,
              onClick: () => triggerRangeChange(btn.range()),
            }))}
          />
        ) : null,
      ]}
      mapDays={({ date }) => {
        const jsDate = date.toDate();
        if (!isDateAllowed(jsDate)) {
          return {
            disabled: true,
            style: { color: "#ccc", backgroundColor: "#f8f8f8" },
          };
        }
      }}
    />
  );
};

export default CustomCalender;
